const errors = [
  {
    path: '/:pathMatch(.*)*',
    name: 'Error',
    component: () => import('@/view/pages/shared/error/Page404.vue'),
  },
  {
    path: '/maintenance', // Caminho específico para a página de manutenção
    name: 'Manutenção',
    component: () => import('@/view/pages/shared/error/Maintenance.vue'),
  },
]

export default errors
